exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-60c98368]{margin:0;padding:0;box-sizing:border-box}.tabs-head[data-v-60c98368]{display:flex;height:40px;justify-content:flex-start;position:relative;border-bottom:1px solid #ddd}.tabs-head>.line[data-v-60c98368]{position:absolute;bottom:0;border-bottom:2px solid #4a90e2;transition:all .3s}.tabs-head>.actions-wrapper[data-v-60c98368]{margin-left:auto;display:flex;justify-content:center;align-items:center;padding:0 1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60c98368","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/tabs/bf-tabs-head/bf-tabs-head.vue
// module id = 77
// module chunks = 0